<script lang="ts">
  /* A small piece of state you read at a glance.
   *
   * For the facts that have to be visible without opening anything: PARKED
   * 06:40 in the command bar, "no wait" against a departure option, "7 of 14
   * on" beside the layers header.
   *
   * Nielsen Norman are explicit that always-needed state must not live inside a
   * panel the user has to open, and the parked time cursor is the clearest case
   * this app has — it means every tide bar, stream arrow and current field on
   * the chart behind it is drawn for another moment.
   */
  import type { Snippet } from 'svelte';

  let {
    tone = 'neutral',
    children
  }: { tone?: 'neutral' | 'on' | 'warn'; children: Snippet } = $props();
</script>

<span class="chip {tone}">{@render children()}</span>

<style>
  .chip {
    display: inline-flex;
    align-items: center;
    gap: var(--sp-3);
    padding: var(--sp-2) var(--sp-4);
    border: 1px solid var(--line);
    border-radius: var(--r-pill);
    background: var(--s-2);
    font: var(--fs-label) / 1 var(--px);
    letter-spacing: var(--tr-label);
    color: var(--sub);
    text-transform: uppercase;
    white-space: nowrap;
  }
  .on {
    border-color: var(--cy-line);
    background: var(--cy-weak);
    color: var(--cy);
  }
  .warn {
    border-color: var(--am-line);
    background: var(--am-weak);
    color: var(--am);
  }
</style>
